import React, { useEffect, useRef, useCallback, useMemo, useContext, useState } from 'react';
import { TreeView, TreeViewRef } from 'devextreme-react/tree-view';
import * as events from 'devextreme/events';
import { navigation } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';
import type { SideNavigationMenuProps } from '../../types';
import { useAuth } from './../../contexts/auth';

import { ThemeContext } from '../../theme';
import axios from 'axios';
import { auth } from '../../firebase';

export default function SideNavigationMenu(props: React.PropsWithChildren<SideNavigationMenuProps>) {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const [userData, setUserData] = useState<any>(null);
  useEffect(() => {
    if (user) {
      getUserData();
    }
  }, [user]);

  const getUserData = () => {
    const email = auth.currentUser?.email;
    axios.get(`${baseUrl}/api/User/userByEmail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setUserData(response.data.data))
      .catch(error => console.error('Error fetching users:', error))
      .finally();
    };

  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const theme = useContext(ThemeContext);
  const { isLarge } = useScreenSize();

  const normalizePath = useCallback(() => {
    return navigation.map((item) => (
      { 
        ...item, 
        expanded: isLarge, 
        path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path,
        visible: (item.visible.length === 0) ? true : (item.visible.includes(userData?.role?.name))
      }
    ))
  }, [userData]);  

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userData]
  );

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef<TreeViewRef>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const getWrapperRef = useCallback((element: HTMLDivElement) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e: React.PointerEvent) => {
      openMenu(e);
    });
  }, [openMenu]);

  

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance();
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div
      className={`dx-swatch-additional${theme?.isDark() ? '-dark' : ''} side-navigation-menu`}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
